var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center flex-wrap"},_vm._l((_vm.content.plans),function(plan,i){return _c('Plan',{key:i,attrs:{"plan":plan}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }